<section id="main">
  <div class="container-fluid">
    <!-- START Title -->
    <div class="row">
      <div class="viber-ctn" style="position: relative;">
        <img class="img-ctn" src="img/hypo/addikochat.png"/>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 t-a-c p-t-15 ">
        <h4 class="c-appblue" translate="viber.conditionHeader"></h4>
        <h4 class="c-appblue underline" translate="viber.conditionHeader2"></h4>
      </div>
    </div>

    <div class="row p-b-15">
      <div class="col-sm-12">
        <div class="image">
          <img src="img/hypo/viber/sl-v1.png" alt="" />
          <!--<h2>A Movie in the Park:<br />Kung Fu Panda</h2>-->

            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text1"></div>
            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text2"></div>
            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text3"></div>
            <div class="col-xs-3 p-10 t-a-c c-appblue" translate="viber.text4"></div>

        </div>
      </div>

    </div>

    <div class="row" style="margin-top:10px;">
      <div class="col-sm-12 viber-txt-center">
          <label class="viber-display-inline">
            <a ng-href="{{viber.conditionLink}}" target="_blank" style="color:blue;" translate ="viber.viberCondition1"></a>
          </label>
        <label class="viber-display-inline">{{viber.bankAddition}} {{APP_GLOBAL_SETTINGS.defaultData.BiHLocation}}</label>
        <label class="viber-display-inline" translate="viber.viberCondition2"></label>
        <label class="viber-display-inline"><a href="https://www.viber.com/en/terms" target="_blank" style="color:blue;" translate="viber.viberCondition3"></a></label>
        <label class="viber-display-inline" translate="viber.viberCondition4"></label>
      </div>

      <div class="col-sm-12 viber-txt-center p-t-10">
        <label class="checkbox checkbox-inline-inline m-r-20 checkbox-value ng-binding">
          <label class="p-0" translate="viber.agree">Slažem se sa Opštim uvjetima Vajber banke</label>
          <input type="checkbox" ng-model="viber.agree">
          <i class="input-helper"></i>
        </label>
      </div>
    </div>



    <div class="row">


      <div class="col-sm-12 t-a-c">
        <button class="btn btn-default" data-ui-sref="{{viber.checkViberActivation() ? 'viber.activate-new' : 'viber.activate'}}" ng-disabled="!viber.agree" translate="viber.activate">
          Aktiviraj
        </button>
      </div>

    </div>

  </div>
</section>
